<template>
  <form
    id="program-users"
    ref="program-users-form"
    class="tw-max-w-full md:tw-w-2/3 tw-flex-shrink-0 tw-mb-20 auth-card tw-flex tw-flex-wrap"
    method="post"
    action="/program/users"
    @submit.prevent="onSubmit"
  >
    <div class="tw-w-full tw-mb-4 tw-flex-shrink-0 tw-px-1">
      <SelectGroup
        :class="{ '--loading-data': loadingForm }"
        label="Select user(s)"
        name="user"
        nameKey="label"
        placeholder="Select user(s)"
        input-classes="my-select--huge tw-bg-gray-200 tw-text-left"
        v-model="selectedUsers"
        :options="companyUsers"
        :reduce="user => user.id"
        :clearable="false"
        :filterable="true"
        :multiple="true"
        :error="selectedUsersError"
      />
    </div>

    <div class="tw-w-full tw-mb-4 tw-flex-shrink-0 tw-px-1">
      <SelectGroup
        :class="{ '--loading-data': loadingForm }"
        label="Select how to onboard user(s)"
        name="user"
        nameKey="label"
        placeholder="Select how to onboard user(s)"
        input-classes="my-select--huge tw-bg-gray-200 tw-text-left"
        v-model="selectedOnboardingOption"
        :options="onboardingOptions"
        :reduce="option => option.id"
        :clearable="false"
        :error="onboardingOptionsError"
      />
    </div>

    <div class="tw-w-full tw-flex-shrink-0 tw-px-1 tw-mb-4 tw-pt-20">
      <BaseButton
        type="submit"
        :class="[
          'tw-block tw-w-full md:tw-inline-block md:tw-w-auto tw-mb-4 tw-py-3 tw-px-8',
        ]"
        :text="btnText"
        :disabled="!canSubmit || btnDisabled"
      />
    </div>
  </form>
</template>

<script>
import SelectGroup from '@/components/SelectGroup.vue';
// import BaseCheckBox from '@/components/BaseCheckBox.vue';

const REQUEST_OPTION = 'request';
const JOIN_OPTION = 'join';

export default {
  name: 'EditCompanyProgramUsers',
  components: {
    SelectGroup,
    // BaseCheckBox,
  },
  props: {
    companyProgram: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loadingForm: false,
      errorForm: false,
      isSubmitting: false,
      btnText: 'Add User(s)',
      btnDisabled: false,
      companyUsers: [],
      selectedUsers: [],
      selectedUsersError: undefined,
      onboardingOptionsError: undefined,
      selectedOnboardingOption: undefined,
    };
  },
  computed: {
    canSubmit() {
      return this.selectedUsers.length && this.selectedOnboardingOption?.length;
    },
    onboardingOptions() {
      return [
        {
          id: REQUEST_OPTION,
          label: 'Send request to users(s) [recommended]',
        },
        {
          id: JOIN_OPTION,
          label: 'Add users to program',
        },
      ];
    },
  },
  methods: {
    async loadForm() {
      this.loadingForm = true;
      this.errorForm = undefined;

      await this.$nextTick();

      const formData = {
        programId: this.companyProgram.id,
        companyId: this.companyProgram.companyid,
      };

      const users = await this.$store.dispatch('getUsersNotInProgram', formData);
      await this.$nextTick();

      if (!users) {
        const errorMessage = 'error in getting users.';
        this.loadingForm = false;
        this.errorForm = errorMessage;

        console.error('loadForm::loadForm err', errorMessage);

        this.$toasted.global.appError({
          errorMessage: `${errorMessage} Please try again later`,
        });

        return;
      }

      this.companyUsers = users.map((c) => ({
        id: c.id,
        label: `${c.name} ${c.middle || c.last_name} [${c.gender?.gender}] (${c.email}) ${c.requested ? '- pending request' : ''}`,
      }));

      await this.$nextTick();

      this.loadingForm = false;
      this.errorForm = undefined;
    },
    async addSelectedUsersToProgram() {
      if (!this.canSubmit) return false;

      this.isSubmitting = true;
      this.$toasted.info('Adding users(s), please wait', { duration: 3000 });

      const prom = [];
      this.selectedUsers.forEach((id) => {
        const formData = {
          progid: this.companyProgram.id,
          userid: id,
        };

        prom.push(
          this.$store.dispatch('addUserToProgram', formData),
        );
      });

      const result = await Promise.all(prom);

      this.isSubmitting = false;

      return result.every((res) => res);
    },
    async sendRequestsToSelectedUsers() {
      if (!this.canSubmit) return false;

      this.isSubmitting = true;
      this.$toasted.info('Adding users(s), please wait', { duration: 3000 });

      const prom = [];
      this.selectedUsers.forEach((id) => {
        const formData = {
          progid: this.companyProgram.id,
          userid: id,
        };

        prom.push(
          this.$store.dispatch('requestUserToJoinProgram', formData),
        );
      });

      const result = await Promise.all(prom);

      this.isSubmitting = false;

      return result.every((res) => res);
    },
    async onSubmit() {
      if (!this.canSubmit) return;

      this.btnDisabled = true;

      let result;
      if (this.selectedOnboardingOption === JOIN_OPTION) {
        result = await this.addSelectedUsersToProgram();
      } else {
        result = await this.sendRequestsToSelectedUsers();
      }

      await this.$nextTick();

      if (!result) {
        // toast error
        this.$toasted.global.appError();
        this.btnDisabled = false;
        return;
      }

      this.$toasted.success('Success!', { duration: 3000 });
      this.$emit('saved');

      this.loadForm();

      this.btnDisabled = false;
    },
  },
  async mounted() {
    await this.$nextTick();

    this.loadForm();

    await this.$nextTick();
  },
};
</script>

<style>

</style>
